import request from '@/utils/request'

export function login(data) {
  return request({
    url: `/us/users/open/login`,
    method: 'post',
    data
  })
}

export function get() {
  return request({
    url: `/us/users/info`,
    method: 'get'
  })
}

export function modify(data) {
  return request({
    url: `/us/users/info`,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js